import { Link } from 'react-router-dom';
import LogoContainer from '../../components/LogoTextComponent';
import { TerminalPageContainer, TextContainer } from '../MainPage/styles';

export default function NotFoundPage(props) {
  const { resetError } = props;
  return (
    <TerminalPageContainer>
      <LogoContainer />
      <TextContainer>
        <h5>Warning!!! An error has occured on the server!</h5>
        <h3>The warning has been recorded, re-access the server to restore your previous session!</h3>
      </TextContainer>
      <p>
        Access the server directly at{' '}
        {resetError ? (
          <Link to="/" onClick={resetError}>
            https://serverheist.com
          </Link>
        ) : (
          <Link to="/">https://serverheist.com</Link>
        )}
      </p>
    </TerminalPageContainer>
  );
}
